import CampusTierLanding from "@/components/site/CampusTierLanding";
export default function CampusProPage() {
  return <CampusTierLanding tier="pro" />;
}
